import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
@Component({

    template: `<router-outlet></router-outlet>`,
  standalone: false
})
export class NewsComponent { 
     constructor(private http: HttpClient) {
    }
    ngOnInit(): void {
        document.querySelector("body").classList.remove("opened");
    }
}
